import polarDistance from './polarDistance'

export const getGeoLocation = (options = {}) =>
  new Promise((resolve, reject) => {
    if (!'geolocation' in navigator) return reject('Geolocation not supported')
    const defaultOptions = {
      enableHightAcurracy: true,
      timeout: 30000,
      maximumAge: 60000,
    }
    navigator.geolocation.getCurrentPosition(
      result => resolve(result),
      error => reject(error),
      { ...defaultOptions, ...options }
    )
  })

export const shortCoords = geo => ({
  lat: geo.latitude,
  lng: geo.longitude,
})

export const getDeviceStatus = async () => ({
  battery:
    !'getBattery' in navigator ? null : (await navigator.getBattery()).level,
  clock: new Date().toISOString(),
  network:
    !'connection' in navigator
      ? null
      : navigator.connection.type || navigator.connection.effectiveType,
})

export const distanceFromPoint = async reference =>
  getGeoLocation()
    .then(({ coords }) => coords)
    .then(user =>
      polarDistance(
        reference.latitude,
        reference.longitude,
        user.latitude,
        user.longitude
      )
    )
